module.exports = __webpack_public_path__ + "static/media/schedule_structure_remove_a_day.8f5d2b30.mov";